import { useDispatch } from 'react-redux'

// NOTE: old pattern.  import useDispatch from react-redux directly

export default useDispatch
